import React from 'react';

import { Container } from './styles';

const WrapperHeader: React.FC = ({ children }) => (
  <Container>
    {children}
  </Container>
);
export default WrapperHeader;
